import { PlanLevel } from './plan-level';

/** used for determining if upgrading or downgrading when selecting a plan */
export const PlanRank: Record<PlanLevel, number> = {
  [PlanLevel.Thrive]: 4,
  [PlanLevel.Accelerate]: 3,
  [PlanLevel.Essentials]: 2,
  [PlanLevel.Freemium]: 1,
};
